import { tokens } from '../../tokens/underlyingTokens';
import type { VToken } from '../../types';

export const unichainMainnet: VToken[] = [
  {
    chainId: 130,
    address: '0xc219BC179C7cDb37eACB03f993f9fDc2495e3374',
    decimals: 8,
    symbol: 'vWETH_Core',
    underlyingToken: tokens[130][1],
  },
  {
    chainId: 130,
    address: '0xB953f92B9f759d97d2F2Dec10A8A3cf75fcE3A95',
    decimals: 8,
    symbol: 'vUSDC_Core',
    underlyingToken: tokens[130][2],
  },
  {
    chainId: 130,
    address: '0x67716D6Bf76170Af816F5735e14c4d44D0B05eD2',
    decimals: 8,
    symbol: 'vUNI_Core',
    underlyingToken: tokens[130][4],
  },
  {
    chainId: 130,
    address: '0x0170398083eb0D0387709523baFCA6426146C218',
    decimals: 8,
    symbol: 'vweETH_Core',
    underlyingToken: tokens[130][5],
  },
  {
    chainId: 130,
    address: '0xbEC19Bef402C697a7be315d3e59E5F65b89Fa1BB',
    decimals: 8,
    symbol: 'vwstETH_Core',
    underlyingToken: tokens[130][6],
  },
  {
    chainId: 130,
    address: '0x68e2A6F7257FAc2F5a557b9E83E1fE6D5B408CE5',
    decimals: 8,
    symbol: 'vWBTC_Core',
    underlyingToken: tokens[130][8],
  },
  {
    chainId: 130,
    address: '0xDa7Ce7Ba016d266645712e2e4Ebc6cC75eA8E4CD',
    decimals: 8,
    symbol: 'vUSD₮0_Core',
    underlyingToken: tokens[130][7],
  },
];
